import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./HeroSection1.css";
import Slider from "react-slick";
import logo from '../../../images/Logo.png'


const CrowselCard = () => {
  const cardsObj = [
    { id: 1, title: "AWS Cloud", description: "Winner Knowledge Bytes" },
    { id: 2, title: "Data Science", description: "Winner Knowledge Bytes" },
    { id: 3, title: "Python Essential", description: "Winner Knowledge Bytes" },
    { id: 4, title: "Web Fullstack", description: "Winner Knowledge Bytes" },
    { id: 5, title: "Cyber Security", description: "Winner Knowledge Bytes" },
    { id: 6, title: "Machine Learning", description: "Winner Knowledge Bytes" },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="container py-2">
      <h4 className="mb-4 text-start">Winner of Knowledge Bytes:</h4>
      <Slider {...settings}>
        {cardsObj.map((card) => (
          <div key={card.id} className="d-flex justify-content-center mt-3">
            <div
              className="card p-3 d-flex flex-column shadow-sm rounded hover-effect"
              style={{ height: "170px", width: "90%"}}
            >
              <img 
          src={logo} 
          alt="Logo" 
          className="position-absolute" 
          style={{ top: "10px", right: "10px", width: "50px", height: "45px", opacity: "0.9" }}
        />
              <h5 className="card-title text-start fs-6">{card.title}</h5>
              <p className="text-start  text-dark flex-grow-1 mt-auto">{card.description}</p>
              <div className="text-center mt-auto">
                <button className="btn btn-primary w-75">Watch Now</button>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default CrowselCard;
